import React from 'react';
import { LeafIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { IMAGES } from '../../data/links';
const stats = [{
  value: '21',
  label: 'Days'
}, {
  value: '15',
  label: 'Min a day'
}, {
  value: '1',
  label: 'Practice system'
}];
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-211" data-mp="hw8vxs0n3xob">
      <div className="mx-auto max-w-4xl text-center" data-id="element-212" data-mp="mutw5rfw6hcr">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-213" data-mp="ms7qxygh4dxp">
          <span className="flex items-center gap-2" data-id="element-214" data-mp="qu2r2zmo4l9w">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-forest text-cream" data-id="element-215" data-mp="vlu7wig0vcmu">
              <LeafIcon className="h-5 w-5" aria-hidden="true" data-id="element-216" data-mp="10lysoknyqtiv" />
            </span>
            <span className="font-serif text-xl font-bold text-forest" data-id="element-217" data-mp="15ks3u6fs28fv">Elly Delgado</span>
          </span>
          <span className="rounded-full border border-forest/15 bg-paper px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-forest" data-id="element-218" data-mp="1ajd3a3n7go39">
            21-Day Practice Method™
          </span>
        </div>

        <h1 className="mt-6 font-serif text-[36px] font-extrabold leading-[1.06] text-ink sm:text-5xl md:text-6xl" data-id="element-219" data-mp="4ogdvfgqhgfu">
          Build a reflexology practice in{' '}
          <em className="text-forest" data-id="element-220" data-mp="3vwu6i02joie0">just 21 days</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-221" data-mp="3rv0cgamuucmt">
          Spend just <strong className="text-ink" data-id="element-222" data-mp="sdis0dc5sr5l">15 minutes a day</strong> and follow Elly Delgado's step-by-step method to study,
          practice, and reinforce the fundamentals of reflexology — without getting lost between charts, videos, notes, and
          scattered resources.
        </p>

        <dl className="mx-auto mt-7 grid max-w-md grid-cols-3 divide-x divide-forest/15 rounded-2xl bg-paper py-3 shadow-sm" data-id="element-223" data-mp="eme0xzmux76v">
          {stats.map(s => <div key={s.label} className="px-2" data-id="element-224" data-mp="16djutybzi8np">
              <dt className="sr-only" data-id="element-225" data-mp="16csaxkrr1zd9">{s.label}</dt>
              <dd className="font-serif text-3xl font-bold text-forest" data-id="element-226" data-mp="30ldyf10uc0md">{s.value}</dd>
              <dd className="text-[11px] font-semibold uppercase tracking-wide text-muted" data-id="element-227" data-mp="35kqsa5q4q7yg">{s.label}</dd>
            </div>)}
        </dl>

        <img src={IMAGES.mainMockup} alt="Reflexology 21-Day Practice Method: 6 volumes, planner, study cards and 5 bonuses" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-228" data-mp="2qvkw6qml8xus" />

        <div className="mt-4" data-id="element-229" data-mp="2hu4l0gny8rpi">
          <CTAButton id="first-cta" label="Yes! I want to start my reflexology practice" note="Instant Digital Access · One-Time Payment of $27 · Lifetime Access · 7-Day Guarantee" data-id="element-230" data-mp="2muiwy9so8lst" />
          <Countdown data-id="element-231" data-mp="2cvjlkjgiuc24" />
          <p className="mt-5 text-base font-semibold text-forest" data-id="element-232" data-mp="2cx4i2emec52m">Start your 21-day reflexology practice today.</p>
          <p className="mt-1 text-sm text-muted" data-id="element-233" data-mp="66ofwraowv95">One-time payment · Instant access · Lifetime access</p>
        </div>
      </div>
    </header>;
}